<template>
    <div>
        <v-card>
           <v-card-text>
             <h2>{{ title }}</h2>
                <apexchart type="donut" height="350" :options="chartOptions" :series="seriesData"></apexchart>
           </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    props: ['seriesData', 'headings', 'title'],
    data: () => ({
        series: [],
        chartOptions: {
            labels: [],
            dataLabels: {
                enabled: false
            },
            responsive: [{
                breakpoint: 960,
                options: {
                    chart: {
                        width: 290
                    },
                    legend: {
                        show: true
                    }
                }
            }],
            legend: {
                position: 'bottom',
            }
        },
    }),

    created() {
        //console.log('values', this.seriesData)
        //console.log('dates', this.headings)
        this.chartOptions.labels = this.headings
    }
}
</script>